import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";

Html.registerWidget('widget/form/checkbox',{init:init})

export function init(elem){
    
  let 
    input = elem.find('input'), 
    isRadio = elem.attr('data-type')==='radio',
    icon = elem.find("icon").last();
    
  var updater = function(){
    icon.html(input.prop("checked")?Icons.ic_checked.toString():Icons.ic_checkbox.toString())
  }
  if(input.attr("disabled")){
    icon.css('color',"#ccc")
  }else{
    elem.css("cursor","pointer")
  }
  updater();
  
  input.on('blur',updater)
  elem.on('click',function(){
    if(input.attr("disabled")){
      return;
    }
    if(isRadio){
      $(input.parents('form').get(0)[input.attr('name')]).prop("checked",false).trigger('blur');
      input.prop("checked",true).trigger('blur');
    }else{
      var newval = !input.prop("checked");
      input.prop("checked",newval).trigger('blur');
    }
    
  });
  return input
}
